var map = {
	"./back_icono.jpg": 6035,
	"./backgroundNV1.png": 3338,
	"./background_general_old2.jpg": 5971,
	"./bg_bnx_12.jpg": 2563,
	"./bg_bnx_12_lateral.jpg": 8836,
	"./bg_citi_10.png": 1159,
	"./fecha_8_oct_2026.png": 701,
	"./fecha_8_oct_2026_en.png": 2840,
	"./office_friends_working_vertical.jpg": 45,
	"./ponentes/Andrew.png": 2797,
	"./ponentes/April.jpg": 4843,
	"./ponentes/Rosalinda_Sept.png": 9857
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1533;